import type { NotifyOptionsSuccess, NotifyOptionsError, NotifierConfig } from "@modernary/mui/components/notifications";
import type { AccessRequest } from "@/views/accessRequest/accessRequest";
import { apiService } from "@modernary/mui/utils/api";
import { apiHosts } from "@/api/constants/apiHosts";

const URL = "access-requests";
const ENTITY_NAME = "Request";

const axiosParams = {
  // Set different base URL based on the environment
  baseURL: import.meta.env.VITE_ODR_API_BASE_URL,
};
const api = apiService<AccessRequest>(apiHosts.ODR, axiosParams);

const createAccessRequest = (accessRequest: AccessRequest, config: NotifierConfig = {}) => {
  const successNotifCb = (options: NotifyOptionsSuccess) => {
    options.title = "Access Request Submitted";
    config?.successNotifCb?.(options);
  };
  const errorNotifCb = (options: NotifyOptionsError) => {
    options.created = ENTITY_NAME;
    config?.errorNotifCb?.(options);
  };

  return api.post(URL, accessRequest, {
    successNotifCb,
    errorNotifCb,
  });
};

export { createAccessRequest };
